export interface Anime {
  id: number;
  title: string;
  cover: string;
  category: string;
  categorySlug: string;
  episodes: number;
  status: '完结' | '连载中';
  rating: number;
  description: string;
  year: number;
  season: string;
  updatedAt: string;
  tags: string[];
  longDescription: string;
  director: string;
  studio: string;
  views: number;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '热血', slug: 'rexue' },
  { name: '搞笑', slug: 'gaoxiao' },
  { name: '恋爱', slug: 'lianai' },
  { name: '奇幻', slug: 'qihuan' },
  { name: '悬疑', slug: 'xuanyi' },
  { name: '冒险', slug: 'maoxian' },
  { name: '校园', slug: 'xiaoyuan' },
  { name: '治愈', slug: 'zhiyu' },
  { name: '科幻', slug: 'kehuan' },
  { name: '战斗', slug: 'zhandou' },
];

export const animeList: Anime[] = [
  {
    id: 1,
    title: '烈焰战魂',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20fierce%20warrior%20with%20flaming%20sword%2C%20dynamic%20action%20pose%2C%20fire%20effects%2C%20dark%20background%20with%20embers%2C%20clean%20anime%20art%20style%2C%20vibrant%20orange%20and%20red%20color%20palette%2C%20dramatic%20lighting%2C%20cinematic%20composition&width=600&height=800&seq=anime-cover-01&orientation=portrait',
    category: '热血',
    categorySlug: 'rexue',
    episodes: 32,
    status: '完结',
    rating: 9.2,
    description: '少年凌云身怀烈焰血脉，为守护家园踏上修炼之路，与伙伴们一起对抗黑暗势力。',
    year: 2024,
    season: '春季',
    updatedAt: '2026-08-04',
    tags: ['热血', '战斗', '冒险', '成长'],
    longDescription: '在一个被黑暗势力威胁的世界中，少年凌云因体内流淌着传说中的烈焰血脉而注定不凡。为了守护家园和所爱之人，他毅然踏上修炼之路。在旅途中，他结识了一群志同道合的伙伴，共同面对无数艰难险阻。从懵懂少年到独当一面的战士，凌云的成长之路充满了热血与感动。32集完整剧情，从开篇到终章一气呵成，带您领略一场史诗级的冒险之旅。',
    director: '陈风',
    studio: '星辰动画工作室',
    views: 1280000,
  },
  {
    id: 2,
    title: '星辰武者',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20martial%20artist%20under%20starry%20night%20sky%2C%20cosmic%20energy%20surrounding%20the%20character%2C%20flowing%20robes%2C%20mountain%20peak%20setting%2C%20ethereal%20blue%20and%20silver%20glow%2C%20clean%20anime%20art%20style%2C%20dreamy%20atmosphere&width=600&height=800&seq=anime-cover-02&orientation=portrait',
    category: '热血',
    categorySlug: 'rexue',
    episodes: 24,
    status: '完结',
    rating: 9.0,
    description: '星辰之力觉醒，少年武者踏上宇宙级对决的征程，解锁星辰奥秘。',
    year: 2025,
    season: '夏季',
    updatedAt: '2026-08-03',
    tags: ['热血', '战斗', '宇宙', '武术'],
    longDescription: '传说中，星辰之力是宇宙间最古老的力量。少年辰逸在一次意外中觉醒了这股力量，从此被卷入了一场跨越星系的宏大对决。从地球到遥远的星系，他不断突破自我极限，解锁星辰的终极奥秘。24集紧凑剧情，每一集都充满惊喜与反转。',
    director: '林宇',
    studio: '银河映像',
    views: 980000,
  },
  {
    id: 3,
    title: '废柴逆袭记',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20goofy%20teenager%20with%20comedic%20expression%2C%20surrounded%20by%20funny%20misfortune%20elements%2C%20bright%20colorful%20background%2C%20slice%20of%20life%20comedy%20vibe%2C%20clean%20anime%20art%20style%2C%20warm%20yellow%20and%20pink%20tones&width=600&height=800&seq=anime-cover-03&orientation=portrait',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    episodes: 48,
    status: '连载中',
    rating: 8.8,
    description: '平凡高中生意外获得系统，从此开启啼笑皆非的逆袭人生。',
    year: 2025,
    season: '秋季',
    updatedAt: '2026-08-05',
    tags: ['搞笑', '校园', '系统流', '日常'],
    longDescription: '高中生王小凡原本是班里公认的废柴，直到有一天他的手机突然弹出一条神秘的"逆袭系统"提示。从此，他的生活发生了翻天覆地的变化——考试满分、运动全能、桃花运爆棚？然而系统的任务总是出人意料，让人哭笑不得。48集长篇搞笑动漫，笑点密集，适合放松心情时观看。',
    director: '张乐',
    studio: '乐翻天动漫',
    views: 2150000,
  },
  {
    id: 4,
    title: '宅男日常',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20relaxed%20otaku%20in%20a%20cozy%20room%20filled%20with%20manga%20and%20snacks%2C%20cat%20sleeping%20nearby%2C%20warm%20afternoon%20light%20through%20window%2C%20comfortable%20slice%20of%20life%20atmosphere%2C%20clean%20anime%20art%20style&width=600&height=800&seq=anime-cover-04&orientation=portrait',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    episodes: 36,
    status: '完结',
    rating: 9.1,
    description: '宅男阿宅和他的猫咪室友的日常爆笑生活，治愈又解压。',
    year: 2024,
    season: '冬季',
    updatedAt: '2026-07-28',
    tags: ['搞笑', '日常', '治愈', '萌宠'],
    longDescription: '阿宅是一个不折不扣的资深宅男，他的人生信条是"能不出门绝不出门"。与他同居的是一只名叫团子的胖橘猫，两人（？）的日常充满了各种无厘头的搞笑事件。从外卖大战到快递风波，从游戏连跪到追番通宵，每一集都能让你笑到肚子疼。36集暖心又搞笑的日常番，最适合在下班后放松观看。',
    director: '刘萌',
    studio: '萌趣工厂',
    views: 1560000,
  },
  {
    id: 5,
    title: '樱花之约',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20couple%20under%20blooming%20cherry%20blossom%20tree%2C%20spring%20atmosphere%2C%20soft%20pink%20petals%20falling%2C%20romantic%20school%20setting%2C%20gentle%20warm%20lighting%2C%20clean%20anime%20art%20style%2C%20dreamy%20bokeh%20effect&width=600&height=800&seq=anime-cover-05&orientation=portrait',
    category: '恋爱',
    categorySlug: 'lianai',
    episodes: 12,
    status: '完结',
    rating: 9.3,
    description: '樱花树下许下的约定，跨越十年的纯爱故事，治愈人心。',
    year: 2025,
    season: '春季',
    updatedAt: '2026-08-01',
    tags: ['恋爱', '纯爱', '校园', '治愈'],
    longDescription: '十年前，他们在樱花树下许下了一个约定。十年后，当两人在高中重逢时，命运的齿轮再次转动。这是一段关于青春、初恋和成长的故事。没有狗血的剧情，只有最纯粹的喜欢和最真挚的情感。12集精短篇幅，每一帧都美得像一幅画，被誉为"年度最唯美恋爱番"。',
    director: '苏樱',
    studio: '花瓣动漫社',
    views: 1890000,
  },
  {
    id: 6,
    title: '心动频率',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20shy%20girl%20and%20boy%20sharing%20earphones%2C%20sunset%20rooftop%20setting%2C%20music%20notes%20floating%20in%20air%2C%20warm%20golden%20hour%20light%2C%20romantic%20youth%20atmosphere%2C%20clean%20anime%20art%20style&width=600&height=800&seq=anime-cover-06&orientation=portrait',
    category: '恋爱',
    categorySlug: 'lianai',
    episodes: 24,
    status: '连载中',
    rating: 8.9,
    description: '音乐社的两位天才因为一首曲子相遇，谱写动人的青春恋曲。',
    year: 2026,
    season: '春季',
    updatedAt: '2026-08-05',
    tags: ['恋爱', '音乐', '校园', '青春'],
    longDescription: '高中音乐社的天才钢琴少女林悦和转学生吉他手陈宇，因为一场校园音乐比赛而相识。两人在音乐中找到了共鸣，也在彼此身上找到了心动的频率。然而音乐梦想和青春恋情之间，他们必须做出选择。24集青春音乐恋爱番，配乐精良，剧情走心。',
    director: '周旋律',
    studio: '音符动漫',
    views: 720000,
  },
  {
    id: 7,
    title: '灵域传说',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20mystical%20spirit%20realm%20with%20floating%20islands%2C%20magical%20creatures%2C%20a%20hero%20holding%20a%20glowing%20staff%2C%20fantasy%20world%20landscape%2C%20vibrant%20purple%20and%20emerald%20color%20palette%2C%20clean%20anime%20art%20style%2C%20epic%20scale&width=600&height=800&seq=anime-cover-07&orientation=portrait',
    category: '奇幻',
    categorySlug: 'qihuan',
    episodes: 52,
    status: '完结',
    rating: 9.4,
    description: '在灵域世界中，少年踏上寻找七大灵器的冒险之旅，展开宏大的奇幻篇章。',
    year: 2024,
    season: '秋季',
    updatedAt: '2026-07-30',
    tags: ['奇幻', '冒险', '魔法', '史诗'],
    longDescription: '灵域，一个由七大灵器维持平衡的奇幻世界。当黑暗势力试图收集所有灵器统治世界时，普通少年云凡意外获得了第一件灵器的认可。从此，他踏上了寻找其余六大灵器的冒险旅程。52集长篇史诗级奇幻动漫，世界观宏大，角色塑造饱满，是不可多得的国产奇幻佳作。',
    director: '方奇幻',
    studio: '幻境工坊',
    views: 3200000,
  },
  {
    id: 8,
    title: '魔法纪元',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20magic%20academy%20student%20casting%20a%20spell%2C%20magical%20circle%20effects%2C%20ancient%20library%20background%2C%20mysterious%20atmosphere%2C%20warm%20candlelight%2C%20clean%20anime%20art%20style%2C%20detailed%20magical%20effects&width=600&height=800&seq=anime-cover-08&orientation=portrait',
    category: '奇幻',
    categorySlug: 'qihuan',
    episodes: 40,
    status: '连载中',
    rating: 9.0,
    description: '魔法学院的新生发现自己是预言中的魔法使者，开启传奇魔法之路。',
    year: 2025,
    season: '冬季',
    updatedAt: '2026-08-04',
    tags: ['奇幻', '魔法', '学院', '成长'],
    longDescription: '在世界最大的魔法学院——星辉学院，每年都会招收来自各地的魔法天才。新生艾琳本以为自己只是一个普通的魔法学徒，却在入学仪式上引发了千年一遇的魔法共鸣。古老的预言揭示，她将成为改变魔法世界的关键人物。40集魔法学院题材动漫，魔法体系严谨，剧情引人入胜。',
    director: '王魔法',
    studio: '星辉映像',
    views: 1450000,
  },
  {
    id: 9,
    title: '暗影追踪',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20detective%20in%20a%20rainy%20city%20alley%2C%20noir%20atmosphere%2C%20shadowy%20figure%20lurking%2C%20mysterious%20mood%2C%20dark%20blue%20and%20gray%20tones%2C%20clean%20anime%20art%20style%2C%20cinematic%20lighting%20with%20neon%20reflections&width=600&height=800&seq=anime-cover-09&orientation=portrait',
    category: '悬疑',
    categorySlug: 'xuanyi',
    episodes: 24,
    status: '完结',
    rating: 9.1,
    description: '天才侦探和神秘少女联手破解连环案件，每个案件背后都隐藏着更大的秘密。',
    year: 2025,
    season: '夏季',
    updatedAt: '2026-08-02',
    tags: ['悬疑', '推理', '犯罪', '都市'],
    longDescription: '雾都市连续发生离奇案件，警方束手无策。天才私家侦探秦明与身份神秘的少女白夜组成搭档，深入调查每一个看似独立的案件。随着调查的推进，他们发现所有案件都指向一个隐藏在暗处的庞大组织。24集高能悬疑动漫，每三集一个案件，环环相扣，烧脑刺激。',
    director: '陈推理',
    studio: '迷雾制作',
    views: 2100000,
  },
  {
    id: 10,
    title: '迷雾之城',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20mysterious%20foggy%20city%20with%20clock%20tower%2C%20steampunk%20elements%2C%20lonely%20figure%20walking%20on%20cobblestone%20street%2C%20eerie%20atmosphere%2C%20muted%20teal%20and%20bronze%20tones%2C%20clean%20anime%20art%20style&width=600&height=800&seq=anime-cover-10&orientation=portrait',
    category: '悬疑',
    categorySlug: 'xuanyi',
    episodes: 36,
    status: '完结',
    rating: 8.7,
    description: '一座被迷雾笼罩的城市，居民们逐渐发现城市中隐藏的惊人秘密。',
    year: 2024,
    season: '秋季',
    updatedAt: '2026-07-25',
    tags: ['悬疑', '奇幻', '都市', '解谜'],
    longDescription: '雾隐市，一座终年被浓雾笼罩的奇特城市。这里的居民世代生活在迷雾之中，早已习以为常。直到有一天，城市中心的古钟突然停止了转动，一系列超自然事件接连发生。一群年轻人开始探寻迷雾背后的真相，却发现自己正在揭开一个足以颠覆整个城市认知的巨大秘密。36集悬疑奇幻动漫，设定新颖，氛围营造出色。',
    director: '林迷雾',
    studio: '雾隐制作社',
    views: 1120000,
  },
  {
    id: 11,
    title: '遗失大陆',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20explorers%20discovering%20an%20ancient%20ruined%20civilization%20in%20a%20lush%20jungle%2C%20mysterious%20ruins%20with%20glowing%20runes%2C%20adventure%20atmosphere%2C%20warm%20tropical%20light%2C%20clean%20anime%20art%20style%2C%20cinematic%20wide%20shot&width=600&height=800&seq=anime-cover-11&orientation=portrait',
    category: '冒险',
    categorySlug: 'maoxian',
    episodes: 60,
    status: '完结',
    rating: 9.5,
    description: '探险队深入未知海域，发现失落文明大陆，开启惊心动魄的探险之旅。',
    year: 2023,
    season: '春季',
    updatedAt: '2026-07-20',
    tags: ['冒险', '探索', '古代文明', '寻宝'],
    longDescription: '一支由考古学家、冒险家和科学家组成的探险队，在一次意外中发现了古代地图上标注的"遗失大陆"。当他们踏上这片从未被现代文明触及的土地时，一个辉煌而神秘的古代文明逐渐展现在眼前。然而大陆上隐藏的危险远超出他们的想象。60集史诗级冒险动漫，被全球粉丝誉为"冒险类动漫的天花板"。',
    director: '赵探险',
    studio: '远航动漫',
    views: 4500000,
  },
  {
    id: 12,
    title: '深海秘境',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20deep%20sea%20exploration%20scene%20with%20bioluminescent%20creatures%2C%20diver%20surrounded%20by%20glowing%20jellyfish%2C%20mysterious%20underwater%20ruins%2C%20beautiful%20ocean%20blue%20and%20teal%20gradient%2C%20clean%20anime%20art%20style&width=600&height=800&seq=anime-cover-12&orientation=portrait',
    category: '冒险',
    categorySlug: 'maoxian',
    episodes: 28,
    status: '连载中',
    rating: 8.9,
    description: '深海探险家发现海底神秘文明，揭开海洋最深处的秘密。',
    year: 2026,
    season: '夏季',
    updatedAt: '2026-08-05',
    tags: ['冒险', '海洋', '科幻', '探索'],
    longDescription: '海洋生物学家苏澜在一次深海探测任务中，意外发现了隐藏在万米深海之下的神秘建筑群。这些建筑的存在彻底颠覆了人类对海洋的认知。随着探索的深入，一个关于远古海洋文明的宏大故事逐渐浮出水面。28集深海探险动漫，画面精美，海洋生物刻画栩栩如生。',
    director: '李深海',
    studio: '蓝色星球动画',
    views: 860000,
  },
  {
    id: 13,
    title: '青春不打烊',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20high%20school%20students%20laughing%20together%20on%20rooftop%2C%20after%20school%20sunset%2C%20warm%20golden%20light%2C%20youthful%20energy%2C%20friendship%20theme%2C%20clean%20anime%20art%20style%2C%20nostalgic%20atmosphere&width=600&height=800&seq=anime-cover-13&orientation=portrait',
    category: '校园',
    categorySlug: 'xiaoyuan',
    episodes: 24,
    status: '完结',
    rating: 9.2,
    description: '一群性格迥异的高中生在校园里发生的青春故事，友情、梦想与成长。',
    year: 2025,
    season: '春季',
    updatedAt: '2026-07-29',
    tags: ['校园', '青春', '友情', '成长'],
    longDescription: '阳光高中三年二班，聚集了一群性格迥异的学生——学霸班长、运动健将、文艺少女、中二病少年。在高中最后一年里，他们一起经历了欢笑与泪水，一起面对升学压力，一起追逐各自的梦想。24集青春校园动漫，每一集都是一个关于青春的小故事，温暖又真实。',
    director: '杨青春',
    studio: '阳光映像',
    views: 1750000,
  },
  {
    id: 14,
    title: '课后战争',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20students%20playing%20strategy%20board%20game%20in%20classroom%20after%20school%2C%20intense%20expressions%2C%20dramatic%20lighting%2C%20competitive%20atmosphere%2C%20clean%20anime%20art%20style%2C%20warm%20classroom%20interior&width=600&height=800&seq=anime-cover-14&orientation=portrait',
    category: '校园',
    categorySlug: 'xiaoyuan',
    episodes: 20,
    status: '完结',
    rating: 8.6,
    description: '放学后的教室里，一场场智力与勇气的较量悄然展开。',
    year: 2024,
    season: '冬季',
    updatedAt: '2026-07-22',
    tags: ['校园', '策略', '竞技', '友情'],
    longDescription: '在看似平静的校园里，每天放学后都会上演一场场惊心动魄的"战争"——不是打架斗殴，而是各种脑力竞技的巅峰对决。象棋、围棋、密室逃脱、知识竞赛……一群热爱挑战的学生组成了"课后战争俱乐部"，用智慧和策略书写属于他们的青春传奇。20集竞技校园动漫，节奏紧凑，智力对决让人大呼过瘾。',
    director: '马策略',
    studio: '智趣动漫',
    views: 680000,
  },
  {
    id: 15,
    title: '猫咪咖啡馆',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20cozy%20cat%20cafe%20interior%20with%20multiple%20cats%2C%20warm%20sunlight%20through%20window%2C%20owner%20petting%20a%20cat%2C%20comfortable%20relaxing%20atmosphere%2C%20clean%20anime%20art%20style%2C%20soft%20pastel%20colors&width=600&height=800&seq=anime-cover-15&orientation=portrait',
    category: '治愈',
    categorySlug: 'zhiyu',
    episodes: 12,
    status: '完结',
    rating: 9.3,
    description: '在城市角落的一家猫咪咖啡馆里，人与猫的温暖相遇故事。',
    year: 2025,
    season: '夏季',
    updatedAt: '2026-07-31',
    tags: ['治愈', '日常', '萌宠', '温馨'],
    longDescription: '在城市一条安静的小巷里，有一家名叫"猫时光"的咖啡馆。这里不仅有香浓的咖啡，还有十几只性格各异的猫咪。每个来到咖啡馆的客人都有自己的故事——失意的上班族、迷茫的学生、孤独的老人……在与猫咪相处的时光里，他们找到了内心的平静和温暖。12集治愈系短篇动漫，看完只想立刻去撸猫。',
    director: '温暖',
    studio: '猫爪动画',
    views: 1980000,
  },
  {
    id: 16,
    title: '小镇故事',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20peaceful%20small%20town%20with%20traditional%20houses%2C%20cherry%20blossom%20trees%2C%20residents%20chatting%20on%20street%2C%20slow%20life%20atmosphere%2C%20warm%20sunset%20light%2C%20clean%20anime%20art%20style%2C%20nostalgic%20feeling&width=600&height=800&seq=anime-cover-16&orientation=portrait',
    category: '治愈',
    categorySlug: 'zhiyu',
    episodes: 26,
    status: '完结',
    rating: 8.8,
    description: '回到故乡小镇的青年，在慢生活中重新找到人生的意义。',
    year: 2024,
    season: '秋季',
    updatedAt: '2026-07-18',
    tags: ['治愈', '日常', '田园', '人生'],
    longDescription: '在大城市打拼多年的青年林远，因一次工作变故决定回到故乡小镇休整一段时间。起初他只是想暂时逃避，却在小镇的慢生活中逐渐找回了生活的本质。热情的邻居、美味的家乡菜、四季分明的自然风光……原来幸福一直就在身边。26集田园治愈动漫，画面温暖细腻，适合在疲惫时静静观赏。',
    director: '安小镇',
    studio: '田园印象',
    views: 1320000,
  },
  {
    id: 17,
    title: '机甲先锋',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20giant%20mecha%20robot%20in%20action%20pose%2C%20futuristic%20city%20background%2C%20energy%20weapons%20glowing%2C%20mechanical%20details%2C%20sci-fi%20atmosphere%2C%20clean%20anime%20art%20style%2C%20metallic%20silver%20and%20cyan%20accents&width=600&height=800&seq=anime-cover-17&orientation=portrait',
    category: '科幻',
    categorySlug: 'kehuan',
    episodes: 48,
    status: '完结',
    rating: 9.1,
    description: '在机甲战争时代，年轻驾驶员与他的机甲共同成长，保卫人类最后的堡垒。',
    year: 2024,
    season: '夏季',
    updatedAt: '2026-08-03',
    tags: ['科幻', '机甲', '战争', '成长'],
    longDescription: '公元2150年，地球资源枯竭，人类建造了巨型移动都市作为最后的堡垒。与此同时，神秘的外星机甲开始入侵。年轻的天才驾驶员雷奥与他的专属机甲"风暴号"并肩作战，从一名新兵成长为人类联军的王牌驾驶员。48集硬核科幻机甲动漫，机甲设计精良，战斗场面震撼。',
    director: '铁机甲',
    studio: '钢铁意志工作室',
    views: 2800000,
  },
  {
    id: 18,
    title: '星际迷途',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20spaceship%20crew%20looking%20at%20a%20distant%20galaxy%20through%20viewport%2C%20vast%20starfield%2C%20sci-fi%20interior%2C%20sense%20of%20wonder%2C%20clean%20anime%20art%20style%2C%20deep%20space%20blues%20and%20purples&width=600&height=800&seq=anime-cover-18&orientation=portrait',
    category: '科幻',
    categorySlug: 'kehuan',
    episodes: 36,
    status: '连载中',
    rating: 8.9,
    description: '宇宙飞船意外偏离航线，船员们在未知星系中展开生存与探索之旅。',
    year: 2026,
    season: '春季',
    updatedAt: '2026-08-05',
    tags: ['科幻', '太空', '探索', '生存'],
    longDescription: '深空探索飞船"希望号"在执行例行任务时，遭遇了前所未有的空间异常，被传送到一个完全未知的星系。飞船受损、通讯中断、资源有限，船员们必须在陌生而危险的环境中求生。更令人震惊的是，他们在这个星系中发现了外星文明的遗迹。36集太空科幻动漫，科学与幻想完美结合。',
    director: '宇航行',
    studio: '星际工坊',
    views: 1050000,
  },
  {
    id: 19,
    title: '剑道至尊',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20swordsman%20in%20traditional%20robes%20holding%20a%20glowing%20blade%2C%20mountain%20peak%20dojo%20setting%2C%20cherry%20blossom%20petals%2C%20martial%20arts%20atmosphere%2C%20clean%20anime%20art%20style%2C%20dramatic%20wind%20effects&width=600&height=800&seq=anime-cover-19&orientation=portrait',
    category: '战斗',
    categorySlug: 'zhandou',
    episodes: 56,
    status: '连载中',
    rating: 9.4,
    description: '少年剑客追求剑道极致，一路挑战各路高手，问鼎剑道至尊之位。',
    year: 2025,
    season: '秋季',
    updatedAt: '2026-08-04',
    tags: ['战斗', '武侠', '剑道', '竞技'],
    longDescription: '在剑道盛行的天元大陆，每十年举办一次的"剑道大典"是所有剑客梦寐以求的舞台。少年剑客叶无锋自幼习剑，天赋异禀，为了追寻剑道的至高境界，他离开师门踏上挑战之路。从无名小卒到剑道至尊，56集热血战斗动漫，剑术对决精彩绝伦，世界观设定磅礴大气。',
    director: '吴剑道',
    studio: '锋芒动画',
    views: 3500000,
  },
  {
    id: 20,
    title: '拳皇之路',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20boxer%20in%20fighting%20stance%20in%20a%20ring%2C%20dramatic%20spotlight%2C%20sweat%20and%20motion%20effects%2C%20intense%20atmosphere%2C%20clean%20anime%20art%20style%2C%20dynamic%20action%20composition&width=600&height=800&seq=anime-cover-20&orientation=portrait',
    category: '战斗',
    categorySlug: 'zhandou',
    episodes: 32,
    status: '完结',
    rating: 8.8,
    description: '街头少年通过拳击改变命运，一步步登上世界拳坛之巅。',
    year: 2024,
    season: '春季',
    updatedAt: '2026-07-27',
    tags: ['战斗', '体育', '拳击', '励志'],
    longDescription: '街头混混阿拳在一次偶然的机会下接触到了拳击运动，从此人生轨迹彻底改变。在教练的悉心指导下，他凭借过人的天赋和不懈的努力，从业余赛场一路打到世界职业拳坛。但是成名的路上充满了诱惑和挑战，他能否守住初心？32集热血体育动漫，拳拳到肉的动作设计和感人至深的成长故事。',
    director: '铁拳',
    studio: '擂台动漫',
    views: 1620000,
  },
  {
    id: 21,
    title: '时空旅人',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20time%20traveler%20standing%20between%20two%20different%20eras%2C%20clock%20gears%20floating%2C%20historical%20and%20futuristic%20elements%20merged%2C%20surreal%20atmosphere%2C%20clean%20anime%20art%20style&width=600&height=800&seq=anime-cover-21&orientation=portrait',
    category: '科幻',
    categorySlug: 'kehuan',
    episodes: 24,
    status: '完结',
    rating: 9.0,
    description: '拥有穿越时空能力的少年，在历史长河中修正错误、守护未来。',
    year: 2025,
    season: '冬季',
    updatedAt: '2026-08-01',
    tags: ['科幻', '时空', '历史', '冒险'],
    longDescription: '十七岁的高中生时宇在整理祖父遗物时，发现了一块可以穿越时空的怀表。从此他能够在不同的历史时期之间穿梭——唐朝的长安、战国时代的战场、未来的科技都市。但他很快意识到，每一次穿越都可能改变历史的走向。24集时空科幻动漫，历史与幻想交织，故事构思巧妙。',
    director: '时光',
    studio: '时光隧道动画',
    views: 1350000,
  },
  {
    id: 22,
    title: '食神传说',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20young%20chef%20presenting%20a%20glowing%20delicious%20dish%2C%20kitchen%20background%2C%20steam%20and%20aroma%20effects%2C%20warm%20atmosphere%2C%20food%20anime%20style%2C%20clean%20art%2C%20rich%20warm%20colors&width=600&height=800&seq=anime-cover-22&orientation=portrait',
    category: '治愈',
    categorySlug: 'zhiyu',
    episodes: 30,
    status: '完结',
    rating: 9.1,
    description: '少年厨师用美食治愈人心，参加全国厨艺大赛的温暖故事。',
    year: 2025,
    season: '夏季',
    updatedAt: '2026-07-26',
    tags: ['治愈', '美食', '竞技', '温暖'],
    longDescription: '少年小厨从小在爷爷的小餐馆长大，继承了爷爷的好厨艺和对美食的热爱。为了将爷爷的味道传递给更多人，他报名参加了全国青年厨艺大赛。在比赛中，他遇到了形形色色的对手和朋友，用一道道精心烹制的菜肴讲述了一个个温暖的故事。30集美食治愈动漫，看完绝对会饿。',
    director: '味美',
    studio: '美味工坊',
    views: 1880000,
  },
  {
    id: 23,
    title: '异能觉醒',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20teenager%20with%20glowing%20psychic%20energy%20around%20hands%2C%20urban%20cityscape%20background%2C%20supernatural%20effects%2C%20dynamic%20pose%2C%20clean%20anime%20art%20style%2C%20vibrant%20energy%20auras&width=600&height=800&seq=anime-cover-23&orientation=portrait',
    category: '热血',
    categorySlug: 'rexue',
    episodes: 36,
    status: '连载中',
    rating: 9.0,
    description: '普通高中生突然觉醒超能力，卷入超能力者世界的纷争与守护。',
    year: 2026,
    season: '夏季',
    updatedAt: '2026-08-05',
    tags: ['热血', '超能力', '都市', '战斗'],
    longDescription: '在一场流星雨之后，世界各地陆续有人觉醒了各种超能力。高中生白夜是其中之一，他发现自己能够操控重力。然而超能力的世界远比他想象的复杂——有维护秩序的"守护者"，也有为所欲为的"破坏者"。当城市面临巨大威胁时，白夜必须做出选择。36集超能力热血动漫，能力设定新颖，战斗场面极具想象力。',
    director: '何异能',
    studio: '觉醒动画',
    views: 890000,
  },
  {
    id: 24,
    title: '幻梦巡游',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20dreamlike%20carnival%20scene%20with%20floating%20lanterns%2C%20fantasy%20creatures%2C%20whimsical%20atmosphere%2C%20magical%20night%20setting%2C%20clean%20anime%20art%20style%2C%20soft%20dreamy%20colors%20with%20fireworks&width=600&height=800&seq=anime-cover-24&orientation=portrait',
    category: '奇幻',
    categorySlug: 'qihuan',
    episodes: 20,
    status: '完结',
    rating: 8.9,
    description: '少女误入梦境世界，在一场盛大的幻梦巡游中寻找回家的路。',
    year: 2025,
    season: '春季',
    updatedAt: '2026-07-23',
    tags: ['奇幻', '梦境', '冒险', '童话'],
    longDescription: '失眠少女小梦在一次偶然的梦境中，跌入了一个光怪陆离的梦境世界——幻梦城。这里正在举办一年一度的"幻梦巡游"，各种奇妙的梦境生物齐聚一堂。为了回到现实世界，小梦必须参加巡游并找到传说中的"醒梦之门"。20集奇幻梦境动漫，画面想象力天马行空，每一帧都美得如梦似幻。',
    director: '梦境',
    studio: '幻梦社',
    views: 950000,
  },
];

export const hotAnimeIds = [11, 7, 19, 1, 15, 5, 9, 3];

export const latestAnimeIds = [3, 23, 12, 18, 6, 19, 8, 17, 10, 21, 13, 22];

export const heroAnimeIds = [11, 7, 19, 5];